export default "/v9.0.0/67e6fde/bundles/opensearch.xml";